// @flow
import React, { Component } from 'react';
import PriceOptionItem from './PriceOptionItem';
import i18n from '../../../../i18n/i18n.js';

type Props = {
    fees: any,
    branding: {
        paywall_buttons_bg_color: string,
    },
    language: String,
    isFeeNull: boolean,
    lng: string,
    paywall_primary_color: Object,
    onSubmit: Function,
    handleBack: Function,
};

type State = {
    priceOption: number,
    selectedOptionType: string,
};

export default class PriceOptionsForm extends Component<Props, State> {
    fees: any;

    //constructor
    constructor(props) {
        super(props);
        this.state = {
            priceOption: null,
            selectedOptionType: '',
        };
    }

    handleSubmit = (e: Object) => {
        e.preventDefault();
        this.props.onSubmit(this.state.priceOption);
    };

    handleClick = item => {
        this.setState({
            priceOption: item.id,
            selectedOptionType: item.access_type.name,
        });
    };

    render() {
        let lng = this.props.lng;
        let backgroundColor = this.props.branding.paywall_buttons_bg_color
            ? this.props.branding.paywall_buttons_bg_color
            : '#00aae6';

        return (
            <form className="inplayer-form" onSubmit={this.handleSubmit}>
                <header>
                    <div className="headline">
                        <h4>{i18n.t('choose_price', { lng })}</h4>
                    </div>
                </header>
                {this.props.fees && this.props.fees.length === 0 ? (
                    <p>There are no price options for this asset.</p>
                ) : (
                    <section
                        id="inplayer_pricing_options"
                        className="align-with-content"
                    >
                        <div className="pricing_container">
                            {this.props.fees &&
                                this.props.fees.length &&
                                this.props.fees.map((item, index) => {
                                    let title = '';
                                    let cost = '';
                                    if (
                                        item.access_type.name === 'subscription'
                                    ) {
                                        title = `${i18n.t(
                                            'subscription_price',
                                            {
                                                lng,
                                            }
                                        )} `;
                                        cost = `${item.amount}${
                                            item.currency
                                        }/${item.access_type.period}`;
                                    } else {
                                        title = `${i18n.t('asset_price', {
                                            lng,
                                        })} `;
                                        cost = `${item.amount}${item.currency}`;
                                    }

                                    return (
                                        <PriceOptionItem
                                            key={`priceoption-${index}`}
                                            handleClick={this.handleClick}
                                            item={item}
                                            title={title}
                                            cost={cost}
                                            branding={this.props.branding}
                                            priceOption={this.state.priceOption}
                                        />
                                    );
                                })}
                        </div>
                    </section>
                )}
                <section id="ipx-maincontent">
                    <div className="priceexplainer">
                        {this.state.selectedOptionType === 'subscription' && (
                            <p className="disclaimer">
                                {i18n.t('paywall_subscription_text', { lng })}
                            </p>
                        )}
                    </div>
                    <div className="price buttonholder">
                        <a
                            onClick={this.props.handleBack}
                            href="#"
                            className="back"
                        >
                            &lang; {i18n.t('modal_back', { lng })}
                        </a>
                        {this.state.priceOption ? (
                            <button
                                id={
                                    this.state.priceOption
                                        ? 'pricing_next_button'
                                        : 'disabled'
                                }
                                style={{
                                    backgroundColor: backgroundColor,
                                    color: '#fff',
                                    border: `solid 1px ${backgroundColor}`,
                                }}
                            >
                                <span className="buttonlabel">
                                    {i18n.t('next_button', { lng })}
                                </span>{' '}
                                <i>&rarr;</i>
                            </button>
                        ) : (
                            <button
                                id={
                                    this.state.priceOption
                                        ? 'pricing_next_button'
                                        : 'disabled'
                                }
                                style={{
                                    border: `solid 1px ${
                                        this.props.branding
                                            .paywall_buttons_bg_color
                                    }`,
                                    color: this.props.branding
                                        .paywall_buttons_bg_color,
                                }}
                                disabled
                            >
                                <span className="buttonlabel">
                                    {i18n.t('next_button', { lng })}
                                </span>{' '}
                                <i>&rarr;</i>
                            </button>
                        )}
                    </div>
                </section>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Forms/PriceOption/index.js